import { IMaintenanceListResponse } from '@/store/api/maintenanceApi';
import { MaintenanceSubmitArgs } from './buildSubmitPayload';

/**
 * Build an optimistic "New" maintenance ticket from the submit args, for instant
 * insertion into the list cache. Replaced by the server refetch on success.
 */
export const buildOptimisticTicket = (
  args: MaintenanceSubmitArgs,
  nowIso: string,
  tempId: number,
): IMaintenanceListResponse => ({
  id: tempId,
  maintenanceRequestId: tempId,
  maintenanceStatus: 'New',
  maintenanceLocation: args.location || '',
  maintenanceProblem: args.problem || '',
  maintenanceCategoryName: args.requestType === 'it' ? 'IT' : args.category || '',
  maintenanceSubCategoryName: args.subCategory || '',
  maintenancePriority: args.severity || '',
  maintenanceDescription: `${args.title}${args.description ? '\n\n' + args.description : ''}`,
  createdOn: nowIso,
  updatedOn: nowIso,
  hasAttachments: (args.attachments?.length ?? 0) > 0,
  files: [],
});
